import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AppRoutes from "./routes/AppRoutes";
import { clearSessionRevoked } from "./redux/slices/userSlice";

const App = () => {
  const dispatch = useDispatch();
  const sessionRevoked = useSelector((state) => state.user.sessionRevoked);

  const returnToLogin = () => {
    dispatch(clearSessionRevoked());
    window.location.assign("/login");
  };

  return (
    <>
      <AppRoutes />
      {sessionRevoked && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-60 px-4">
          <div className="w-full max-w-sm rounded-lg bg-white p-6 text-center shadow-xl">
            <h2 className="mb-2 text-xl font-semibold text-gray-900">
              Logged out
            </h2>
            <p className="mb-5 text-sm text-gray-600">
              Your account was logged in on another device. Please log in again.
            </p>
            <button
              type="button"
              onClick={returnToLogin}
              className="w-full rounded-lg bg-gray-900 px-4 py-3 font-medium text-white hover:bg-black"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default App;
